import { render } from "./WalletConfigView.vue?vue&type=template&id=03e8dea3"
import script from "./WalletConfigView.vue?vue&type=script&lang=js"
export * from "./WalletConfigView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__